
import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Agent } from "@/models/agent";

interface AgentDetailsCardProps {
  agent: Agent | null;
}

const AgentDetailsCard: React.FC<AgentDetailsCardProps> = ({ agent }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Agent Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h3 className="text-sm font-medium">Name</h3>
          <p>{agent?.name}</p>
        </div>
        
        <div>
          <h3 className="text-sm font-medium">Category</h3>
          <p>{agent?.category}</p>
        </div>
        
        <div>
          <h3 className="text-sm font-medium">Pricing</h3>
          <p className="capitalize">{agent?.pricingModel}</p>
        </div>
        
        <div>
          <h3 className="text-sm font-medium">Submission Date</h3>
          <p>{new Date(agent?.createdAt || Date.now()).toLocaleDateString()}</p>
        </div>
        
        <Button variant="default" className="w-full flex items-center gap-2" onClick={() => navigate("/create-agent")}>
          <ArrowRight className="h-4 w-4" />
          Create Another Agent
        </Button>
      </CardContent>
    </Card>
  );
};

export default AgentDetailsCard;
